import React from 'react';

const TourismotionCredentialsFields = ({
  apiUsername,
  apiPassword,
  hasApiPassword,
  onChange
}) => (
  <>
    <div className="divider">Acceso API de Tourismotion</div>

    <div className="form-control w-full">
      <label className="label" htmlFor="platform-api-username">
        <span className="label-text">Email de afiliado</span>
      </label>
      <input
        id="platform-api-username"
        type="email"
        name="apiUsername"
        autoComplete="username"
        value={apiUsername}
        onChange={onChange}
        className="input input-bordered w-full"
        required
      />
    </div>

    <div className="form-control w-full">
      <label className="label" htmlFor="platform-api-password">
        <span className="label-text">Contraseña de afiliado</span>
      </label>
      <input
        id="platform-api-password"
        type="password"
        name="apiPassword"
        autoComplete="current-password"
        value={apiPassword}
        onChange={onChange}
        className="input input-bordered w-full"
        required={!hasApiPassword}
        aria-describedby="platform-api-password-help"
      />
      <span id="platform-api-password-help" className="label-text-alt mt-1">
        {hasApiPassword
          ? 'Ya hay una contraseña cifrada. Déjala vacía para conservarla.'
          : 'Se guardará cifrada dentro de la configuración de la plataforma.'}
      </span>
    </div>
  </>
);

export default TourismotionCredentialsFields;
